import "bootstrap/dist/css/bootstrap.min.css"
import React from 'react';
import './index.css';
import NameForm from "./componentes/App"
import Inicio from "./componentes/inicio"

import {
  BrowserRouter as Router,
  Switch,
  Route,
  
  NavLink
} from "react-router-dom";

const styles= {
  color: 'white',
  
};

class JD extends React.Component {
  render() {   
    return (
      <div>
        <Router>
       
        <header>
          
        
         <nav className="navbar navbar-expand-md navbar-dark bg-dark">
           
           <img src="https://lh3.googleusercontent.com/-gE8QsgrspP0/YFNO4AlnR6I/AAAAAAAAIpw/XDKhu-YF-mQUwDMc7H7SwEPvkjwGryJpQCLcBGAsYHQ/logo.png"
           height="120px" className="ml-auto"  alt="my awesome imagen"></img>
           <h2 style={styles} className="ml-3">Laboratorio de Anatomopatología "Dr. Alipio Hernández"</h2>

           
           
            <NavLink to="/" className="btn btn-dark ml-auto" activeClassName="active">
              Inicio
            </NavLink>
            <NavLink to="/nosotros" className="btn btn-dark" activeClassName="active">
              Nosotros
            </NavLink>
            <NavLink to="/resultados" className="btn btn-dark mr-5" activeClassName="active">
            Resultados
           </NavLink>
             
           
          
          </nav>
          <nav className="navbar navbar-expand-md navbar-dark bg-dark">
          <h6 style={styles} className="ml-auto mr-auto">Salud Premium Club Hospitalito C.A. Carrera 21 esquina calle 15. Casa n° 14-95. Zona Centro. 
        Barquisimeto, Estado Lara.</h6>
        <h6 style={styles} className="ml-auto mr-auto">Contacto: +584245642831</h6>
          </nav>
          </header>
          
        <Switch>
          <Route path="/resultados" exact>
          <NameForm/>
          </Route>

          <Route path="/" exact>
            <Inicio/>
          </Route>
          <Route path="/nosotros" exact>
            Nosotros
          </Route>
          


        </Switch>
        </Router>


    </div>
    );
  }
}




export default JD;
